import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import Card from "components/molecules/card/Card";
import { ICustomerGridCard } from "components/molecules/card/customer-grid-card/CustomerGridCard";
import { CardType } from "lib/helpers/constants/cardTypes";
import { Dispatch, FC, SetStateAction, useState } from "react";
import UpdateCustomerProcess from "../update-customer-process/UpdateCustomerProcess";
import { useThemeContext } from "lib/context/ThemeContext/ThemeContext";
import Button from "components/atoms/button/Button";
import Icon from "components/atoms/icon/Icon";
import { IconType } from "lib/helpers/constants/iconTypes";
import { useTranslation } from "react-i18next";

export interface ICustomersGridViewProps<T> {
  data: T[];
  setIsUpdateModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CustomersGridView: FC<ICustomersGridViewProps<any>> = ({
  data,
  setIsUpdateModalOpen
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [updateData, setUpdateData] = useState<Record<string, any>>();
  const [currentStep, setCurrentFormStep] = useState<number>(1);
  const { themeColors } = useThemeContext();
  const { t } = useTranslation();
  return (
    <>
      <div className="grid  md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2  2xl:grid-cols-3 gap-4">
        {data.map((item) => {
          return (
            <div>
              <Card<ICustomerGridCard<string[]>>
                key={`${item.id}`}
                {...item}
                cardType={CardType.CUSTOMER_GRID_CARD}
                props={{
                  data: item,
                  setUpdateData: setUpdateData,
                  setIsModalOpen: setIsUpdateModalOpen,
                  renderButton: () => (
                    <Button
                      onClick={() => {
                        setUpdateData(item);
                        setIsModalOpen(true);
                      }}
                    >
                      <Icon iconType={IconType.OPTIONS_ICON} />
                    </Button>
                  )
                }}
              />
            </div>
          );
        })}
      </div>
      <ConditionalRender condition={isModalOpen}>
        <UpdateCustomerProcess
          setIsModalOpen={setIsModalOpen}
          themeColors={themeColors}
          hocTitle={`
            ${currentStep === 1
              ? ``
              : currentStep === 2
                ? `${t('Add New Product')}`
                : currentStep === 3
                  ? `${t('Upload file')}`
                  : currentStep === 4
                    ? `${t('Application')}`
                    : currentStep === 8
                      ? `${t('Add New Relation')}`
                      : currentStep === 9
                        ? t("Submit Application")
                        : ""
            }
            `}
          data={updateData ?? ""}
          hocClasses={{
            modalClassName: `${`sm:max-w-[570px] sm:w-full w-full ${currentStep === 1
              ? "md:min-w-[750px] lg:min-w-[1000px] xl:min-w-[1200px] 2xl:min-w-[1200px]"
              : currentStep === 2
                ? "w-full !max-w-[760px]"
                : currentStep === 3
                  ? "sm:max-w-[467px]  md:min-w-[467px] lg:w-[467px]"
                  : (currentStep === 4 || currentStep === 5)
                    ? "md:min-w-[750px]  lg:w-[973px]"
                    : (currentStep === 6 || currentStep === 7)
                      ? "md:min-w-[676px] md:w-[676px] lg:w-[676px] xl:w-[676px] 2xl:min-w-[676px]"
                      : currentStep === 8
                        ? "sm:max-w-[430px] md:min-w-[430px] lg:min-w-[430px] xl:min-w-[430px] 2xl:min-w-[430px]"
                        : (currentStep === 9 || currentStep === 10)
                          ? "!max-w-[950px] w-full"
                          : ""
              }`}`,
            titleClassName: (currentStep === 9 || currentStep === 10) ? "ml-[35px]" : "",
          }}
          hocToggleModal={() => setIsModalOpen(false)}
          onConfirm={() => setIsModalOpen(false)}
          hocisOpen={isModalOpen}
          setHocCurrentStep={setCurrentFormStep}
          hocCurrentStep={currentStep}
          setCurrentFormStep={setCurrentFormStep}
          currentStep={currentStep}
          setStepOnClose={1}
        />
      </ConditionalRender>
    </>
  );
};

export default CustomersGridView;
